// File: RegisterForm.js
import React from 'react';
import { Link } from 'react-router-dom';
export default function Register() {

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center " style={{background:"#EEF2F8"}}>
      <div className="col-md-6 p-5 shadow rounded bg-white">
        <h2 className="text-center mb-4">Register</h2>
        <form>
          <div className="row mb-3">
            <div className="col">
              <label>Full Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Please enter your full name"
                name="fullName"
              />
            </div>
            <div className="col">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Please enter your username"
                name="username"
              />
            </div>
          </div>

          <div className="mb-3">
            <label>Email address</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              name="email"
            />
          </div>

          <div className="mb-3">
            <label>Mobile</label>
            <input
              type="tel"
              className="form-control"
              placeholder="Enter mobile"
              name="mobile"
            />
          </div>

          <div className="mb-3">
            <label>Role</label>
            <select
              className="form-select"
              name="role"
    
            >
              <option value="">Select Role</option>
              <option value="Admin">Operator</option>
              <option value="User">Supervisor</option>
              <option value="Manager">Management</option>
              <option value="Manager">Senior Management</option>
              <option value="Manager">Inspect</option>
            </select>
          </div>

          <div className="row mb-3">
            <div className="col">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Create password"
                name="password"
              />
            </div>
            <div className="col">
              <label>Confirm Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Confirm password"
                name="confirmPassword"
              />
            </div>
          </div>

          <div className="d-grid gap-2 mb-3">
            <button type="submit" className="btn btn-primary rounded-pill">
              Register
            </button>
          </div>

          <div className="text-center">
            Already have an account? <Link to="/">Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
